import script from "./OfLogin.vue?vue&type=script&setup=true&lang=js"
export * from "./OfLogin.vue?vue&type=script&setup=true&lang=js"

import "./OfLogin.vue?vue&type=style&index=0&id=305e012b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-305e012b"]])

export default __exports__